/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {fetchExpressions } from "../../../api/sensorApi";
import { toast } from "react-toastify";
import { useMemo } from "react";

function useFetchFaultySensorData({
    start, end, interval, sensorID, sensorData, isMeasuredWallThicknessChecked
}) {
    const [faultySensorData, setFaultySensorData] = useState(null);
    const requestParams = useMemo(
            () => ({
                sensorData,
                sensorID,
                isMeasuredWallThicknessChecked,
                start,
                end,
                interval,
            }),
            [sensorData, sensorID, isMeasuredWallThicknessChecked, start, end, interval]
        );
    useEffect(() => {
        const requestBody = {
                    subject_filter: `sensor.id ='${requestParams.sensorID}'`,
                    expressions: [
                        "isFaultySensor",
                    ],
                    start: requestParams.start.format("YYYY-MM-DD"),
                    end: requestParams.end.format("YYYY-MM-DD"),
                    interval: requestParams.interval.value,
                }
        if (isMeasuredWallThicknessChecked && sensorData?.isRealSensor) {
            fetchExpressions("SensorExpression", requestBody).then((res) => {
                setFaultySensorData(res?.result[sensorID]?.isFaultySensor?._data);

            }).catch((error) => {
                toast.error(`Cannot fetch faulty sensor data`);
                console.log(error);
            });
        }
        else {
            setFaultySensorData(null);
        }
    }, [start, end, interval, sensorID, isMeasuredWallThicknessChecked])


    return { faultySensorData }
}

export default useFetchFaultySensorData;